export default __webpack_public_path__ + "static/media/airdome-not-inflated.351bed7d.svg";